import React, { useRef, useEffect } from 'react';
import { useGoogleMaps } from '../GoogleMapsProvider';

const SubmissionMap = ({ coordinates, center }) => {
  const mapRef = useRef(null);
  const polygonRef = useRef(null);
  const { isLoaded } = useGoogleMaps();

  useEffect(() => {
    if (isLoaded && mapRef.current && coordinates && coordinates.length > 0) {
      // Initialize map
      const map = new window.google.maps.Map(mapRef.current, {
        center: center || coordinates[0],
        zoom: 18,
        mapTypeId: 'hybrid',
        streetViewControl: false,
      });

      // Draw polygon
      const polygon = new window.google.maps.Polygon({
        paths: coordinates,
        strokeColor: '#ECFF25',
        strokeOpacity: 1,
        strokeWeight: 3,
        fillColor: '#01500A',
        fillOpacity: 0.35,
      });

      polygon.setMap(map);
      polygonRef.current = polygon;

      // Fit bounds to polygon
      const bounds = new window.google.maps.LatLngBounds();
      coordinates.forEach((coord) => bounds.extend(coord));
      map.fitBounds(bounds);
    }

    return () => {
      if (polygonRef.current) {
        polygonRef.current.setMap(null);
      }
    };
  }, [isLoaded, coordinates, center]);

  if (!isLoaded) {
    return <div className="map-loading">Chargement de la carte...</div>;
  }

  if (!coordinates || coordinates.length === 0) {
    return <div className="map-no-data">Aucune donnée de terrain disponible</div>;
  }

  return <div ref={mapRef} className="submission-map" />;
};

export default SubmissionMap;
